/* rs-scripts.js — shared behaviour for the Resilia clone sections */
(function () {
  if (window.__rsInit) return;
  window.__rsInit = true;

  function initVideos(root) {
    root.querySelectorAll('[data-rs-video]:not([data-bound])').forEach(function (card) {
      card.setAttribute('data-bound', '');
      card.addEventListener('click', function () {
        var v = card.querySelector('video');
        if (!v) return;
        if (v.paused) {
          document.querySelectorAll('[data-rs-video] video').forEach(function (o) { if (o !== v) { o.pause(); o.parentNode.classList.remove('is-playing'); } });
          v.muted = false; v.play(); card.classList.add('is-playing');
        } else { v.pause(); card.classList.remove('is-playing'); }
      });
    });
  }

  function initScrollers(root) {
    root.querySelectorAll('[data-rs-scroll]:not([data-bound])').forEach(function (wrap) {
      wrap.setAttribute('data-bound', '');
      var track = wrap.querySelector('[data-rs-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-rs-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = Number(btn.getAttribute('data-rs-dir'));
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-rs-delivery]').forEach(function (el) {
      var days = Number(el.getAttribute('data-rs-delivery')) || 3;
      var d = new Date(); var added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
      el.textContent = d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
    });
  }

  function initCountdown(root) {
    root.querySelectorAll('[data-rs-countdown]:not([data-bound])').forEach(function (el) {
      el.setAttribute('data-bound', '');
      var hours = Number(el.getAttribute('data-rs-countdown')) || 2;
      var key = 'rs-cd-end';
      var end;
      try { end = Number(sessionStorage.getItem(key)); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + hours * 3600000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (left === 0) { end = Date.now() + hours * 3600000; }
        h.textContent = pad(Math.floor(left / 3600000));
        m.textContent = pad(Math.floor(left / 60000) % 60);
        s.textContent = pad(Math.floor(left / 1000) % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  function initAll(root) { initVideos(root); initScrollers(root); initDelivery(root); initCountdown(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
